import type { SquareProps as _SquareProps } from "@chakra-ui/react";
import { Circle as _Circle, forwardRef } from "@chakra-ui/react";

export interface CircleProps extends _SquareProps {}

export const Circle = forwardRef<CircleProps, "div">(({ ...props }, ref) => (
    <_Circle ref={ref} {...props} />
));
